import { createPortal } from 'react-dom'
import { SnapshotDataType } from './PayoffChart'
import PayoffMetaDataDisplay from './PayoffMetaDataDisplay'
import { memo } from 'react'

export type PayoffMetaDataProps = {
    paneContainer: HTMLElement | undefined,
    snapshotData: SnapshotDataType | undefined
    historicalOptionChain: boolean
}

const PayoffMetaData = ({ paneContainer, snapshotData, historicalOptionChain }: PayoffMetaDataProps) => {
    // const { expressionMode, primary, underlying } = useSelector(selectPrimarySecurity)
    // const security = expressionMode ? null : primary && isFnOSecurity(primary) ? underlying : primary
    // const underlyingToken = security ? getSecurityKey(security.exchange, security.code) : ''
    // const securitySnapshot = useSelector(selectSnapshot(underlyingToken))
    // const historicalOptionChainSnapshot = useSelector(selectOptionsChainUnderlyingPrices(underlyingToken))
    // const theme = useTheme()

    return (!paneContainer || !snapshotData) ? null : createPortal(<>
        <div className="pane-meta-container">
            {
                <PayoffMetaDataDisplay snapshotData={snapshotData} />
            }
        </div>
        {/* <Box sx={{
            position: 'absolute',
            top: 5,
            textAlign: 'center',
            width: '100%',
            zIndex: 4,
            pointerEvents: 'none',
            fontSize: '12px'
        }}>
            <span style={{
                fontSize: '9px',
                color: theme.palette.text.secondary
            }}>SPOT</span> {((historicalOptionChain ? (historicalOptionChainSnapshot?.underlyingCurrentPrice??0) : securitySnapshot?.lastTradedPrice) / (security?.priceMultiplier ?? 100)).toFixed(log10(security?.priceMultiplier ?? 100))}
        </Box> */}

    </>, paneContainer)
}

export default memo(PayoffMetaData)